import { useState, useEffect } from 'react';

/**
 * Hook para detectar el tipo de dispositivo
 * @param {number} breakpoint - Punto de quiebre en px (default: 768)
 * @returns {Object} - { isMobile, isTablet, isDesktop, width }
 */
const useResponsive = (breakpoint = 768, tabletBreakpoint = 992) => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: window.innerWidth < breakpoint,
    isTablet: window.innerWidth >= breakpoint && window.innerWidth < tabletBreakpoint,
    isDesktop: window.innerWidth >= tabletBreakpoint,
    width: window.innerWidth
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setDeviceInfo({
        isMobile: width < breakpoint,
        isTablet: width >= breakpoint && width < tabletBreakpoint,
        isDesktop: width >= tabletBreakpoint,
        width
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint, tabletBreakpoint]);

  return deviceInfo;
};

export default useResponsive;
